// Permission names issued by the backend (auth_service.ROLE_PERMISSIONS). The UI uses them only
// to decide what to show; every request is authorised again on the server.
export const P = {
  TRADING_VIEW: "trading.view_own",
  TRADING_EXECUTE: "trading.execute_own",
  // LIVE trading with one's own broker account (role LIVE_TRADER). Only one of the four keys a
  // live order needs — the broker account must also be live-enabled by an admin, the
  // instrument's quantity model verified, and the server flag on.
  TRADING_LIVE: "trading.live_own",
  // authorising LIVE on a broker account (ADMIN) — deliberately not the same as trading live
  BROKER_LIVE_ADMIN: "broker.enable_live",
  BROKER: "broker.connect_own",
  ACCOUNT: "account.manage_own",
  USERS_READ: "users.read",
  // development-era SIMULATION domain (one shared mock broker) — ADMIN only
  SIMULATOR: "simulator.use",
  // OPTIONS verticals. The role grants the right; the broker account's admin-set Options flag
  // (Admin > Users > OPTIONS ACCESS) decides whether it is on. Options SHADOW/LIVE reuse TRADING_LIVE.
  OPTIONS_VIEW: "options.view_own",
  OPTIONS_TRADE: "options.trade_own",
};
